<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-900 to-black flex items-center justify-center p-4">
    <div class="max-w-2xl w-full bg-white rounded-3xl shadow-2xl overflow-hidden transform transition-all">
      <div class="p-8 md:p-12 text-center">
        <!-- Icon/Illustration -->
        <div class="mb-8 flex justify-center">
          <div class="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center text-red-500 animate-pulse">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>

        <h1 class="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">
          ¡No detengas el ritmo de tu negocio!
        </h1>

        <p class="text-lg text-gray-600 mb-10 leading-relaxed">
          Tu periodo actual ha finalizado, pero estamos listos para ayudarte a seguir creciendo. 
          Renueva tu cuenta ahora para reactivar el control de tus clientes y pedidos de forma inmediata.
        </p>

        <div class="flex flex-col md:flex-row gap-4 justify-center">
          <a :href="whatsappUrl" target="_blank" class="inline-flex items-center justify-center px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-bold rounded-2xl transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1">
            <svg class="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.94 3.659 1.437 5.634 1.437h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
            Solucionar Ahora
          </a>
          
          <button @click="logout" class="inline-flex items-center justify-center px-8 py-4 border-2 border-gray-200 hover:border-gray-300 text-gray-500 hover:text-gray-700 font-bold rounded-2xl transition-all bg-transparent">
            Cerrar Sesión
          </button>
        </div>
      </div>
      
      <div class="bg-gray-50 py-6 px-8 border-t border-gray-100 flex justify-between items-center">
        <span class="text-sm text-gray-400 font-medium">Realgestión &copy; {{ new Date().getFullYear() }}</span>
        <div class="flex space-x-2">
          <div class="w-2 h-2 rounded-full bg-red-400"></div>
          <div class="w-2 h-2 rounded-full bg-yellow-400"></div>
          <div class="w-2 h-2 rounded-full bg-green-400"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';

export default {
  computed: {
    whatsappUrl() {
      const domain = window.location.host;
      const message = `quiero renovar mi suscripción de Realgestión, cuenta ${domain}`;
      return `https://wa.me/584244010195?text=${encodeURIComponent(message)}`;
    }
  },
  methods: {
    logout() {
      Inertia.delete(route('logout'));
    }
  }
}
</script>

<style scoped>
@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.05); }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
